import React from "react";
import { io } from "socket.io-client";

const params = new URLSearchParams(window.location.search);
export const access_token = params.get('access_token');
export const admin_id = params.get('admin_id');

// const url = 'https://crash-rgs.staging-server.in';
const url = "https://crash-rgs-test.staging-server.in/"
//const url = 'http://localhost:3001/';

export const socketConn = io(`${url}?access_token=${access_token}`, {
  transports: ["websocket"], // Try WebSocket first, fallback to polling
  // transports: ["websocket"],
  withCredentials: true,
  reconnectionAttempts: 2, // Number of reconnection attempts
  reconnectionDelay: 1000, // Time between reconnection attempts (ms)
  timeout: 20000, // Connection timeout
  forceNew: true, // Force a new connection
  path: "/socket.io/", // Confirm this matches your server configuration
  pingTimeout: 60000, // How long to wait for a pong before considering connection lost (ms)
  pingInterval: 25000, // How often to send ping packets (ms)
  auth: {
    // Add any authentication if required
    // admin_id:admin_id,
    access_token: access_token
  },
});
// socket.connect();
